import React, { memo, useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Switch,
  Typography,
  Box,
  Modal,
  TextField,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { WIDAL_COLUMNS } from "../../../constants";
const Widal = memo(({ widalFormData, setWidalFormData, reportType }) => {
  const handleToggle = (invName, column) => {
    setWidalFormData((prev) => ({
      ...prev,
      data: prev.data.map((row) =>
        row.name === invName
          ? { ...row, [column]: row[column] === "+" ? "-" : "+" }
          : row,
      ),
    }));
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ boxShadow: 3, my: 3 }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  border: "1px solid #40916c",
                  backgroundColor: "#52b788",
                }}
              >
                ANTIBODY TITRE
              </TableCell>
              {WIDAL_COLUMNS.map((col) => (
                <TableCell
                  key={col}
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    border: "1px solid #40916c",
                    backgroundColor: "#52b788",
                  }}
                >
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {widalFormData?.data?.map((row) => (
              <TableRow key={row.name} sx={{ backgroundColor: "#f9fdfb" }}>
                <TableCell
                  sx={{
                    fontWeight: "500",
                    border: "1px solid #40916c",
                    background: "#d8f3dc",
                  }}
                >
                  {row.name}
                </TableCell>
                {WIDAL_COLUMNS.map((col) => (
                  <TableCell
                    key={col}
                    sx={{
                      border: "1px solid #40916c",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Typography variant="body1" sx={{ mr: 1 }}>
                        {row[col] === "+" ? <AddIcon /> : <RemoveIcon />}
                      </Typography>
                      <Switch
                        checked={row[col] === "+"}
                        onChange={() => handleToggle(row.name, col)}
                        color="warning"
                        disabled={reportType === "approval"}
                      />
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
});

export default Widal;
